module.exports = __webpack_public_path__ + "arrow-img-d0262ecc.png";